module.exports = __webpack_public_path__ + "img/sidebar_selected_cabinet.e6a730b3.svg";